import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col main-import" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "create-parag" }, "Листы", -1)
const _hoisted_5 = { class: "import-page" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "create-parag" }, [
  /*#__PURE__*/_createTextVNode(" Название бюллетени "),
  /*#__PURE__*/_createVNode("span", { class: "necessarily" }, "*")
], -1)
const _hoisted_7 = { class: "df" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "main-import__input" }, [
  /*#__PURE__*/_createVNode("input", {
    class: "date-from__Bulletin-date",
    type: "text",
    name: ""
  })
], -1)
const _hoisted_9 = { class: "radio-conficuration create-parag" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "circle-label import-circle",
  id: "circle-label-1"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Показывать для пользователей")
const _hoisted_12 = { class: "df mb-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "mb-1 create-parag" }, [
  /*#__PURE__*/_createTextVNode(" Категория "),
  /*#__PURE__*/_createVNode("span", { class: "necessarily" }, "*")
], -1)
const _hoisted_14 = { class: "import-date" }
const _hoisted_15 = { class: "date-from" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "main-import__parag" }, [
  /*#__PURE__*/_createTextVNode(" Дата с "),
  /*#__PURE__*/_createVNode("span", { class: "necessarily" }, "*")
], -1)
const _hoisted_17 = { class: "input-container" }
const _hoisted_18 = { class: "input-container__border" }
const _hoisted_19 = { class: "date-to" }
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "main-import__parag" }, [
  /*#__PURE__*/_createTextVNode(" Дата до "),
  /*#__PURE__*/_createVNode("span", { class: "necessarily" }, "*")
], -1)
const _hoisted_21 = { class: "input-container" }
const _hoisted_22 = { class: "input-container__border" }
const _hoisted_23 = { class: "import-next-table" }
const _hoisted_24 = { class: "import-box" }
const _hoisted_25 = /*#__PURE__*/_createVNode("option", { value: "none" }, "-", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("option", { value: "attr" }, "Атрибут", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("option", { value: "loc" }, "Локация", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("option", { value: "bilut" }, "Название бюллетени", -1)
const _hoisted_29 = {
  key: 0,
  class: "input-box"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("input", {
  class: "input-box__input",
  type: "text",
  name: "",
  placeholder: "Ед. измерения"
}, null, -1)
const _hoisted_31 = { class: "buttons" }
const _hoisted_32 = /*#__PURE__*/_createVNode("button", { class: "button-cancel" }, "ОТМЕНА", -1)
const _hoisted_33 = { class: "import-error-messsage" }
const _hoisted_34 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = { class: "modalcontent" }
const _hoisted_37 = /*#__PURE__*/_createVNode("h2", { class: "modalcontent__h2" }, "Успешно импортировано!", -1)
const _hoisted_38 = { class: "modalcontent__margin modalcontent__margin-faq" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_admin_import = _resolveComponent("admin-import")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_admin_import),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.batchList, (list, index) => {
              return (_openBlock(), _createBlock("button", {
                class: "import-page__button",
                key: index,
                onClick: $event => (_ctx.bulletinList(list.id))
              }, _toDisplayString(index + 1), 9, ["onClick"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("label", _hoisted_9, [
              _withDirectives(_createVNode("input", {
                class: "input-checked",
                type: "checkbox",
                name: "drone",
                value: "location",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.checkboxBulletinStaus = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxBulletinStaus]
              ]),
              _hoisted_10,
              _hoisted_11
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", null, [
              _hoisted_13,
              _withDirectives(_createVNode("select", {
                name: "",
                id: "",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.selectBulletinCategory = $event))
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinCategories, (category) => {
                  return (_openBlock(), _createBlock("option", {
                    value: category.id,
                    key: category.id
                  }, _toDisplayString(category.name), 9, ["value"]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512), [
                [_vModelSelect, _ctx.selectBulletinCategory]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("div", null, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _withDirectives(_createVNode("input", {
                      type: "date",
                      name: "trip-start",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.postData.fromDate = $event)),
                      class: "edit-date__calendar"
                    }, null, 512), [
                      [_vModelText, _ctx.postData.fromDate]
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("div", null, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _withDirectives(_createVNode("input", {
                      type: "date",
                      name: "trip-start",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.postData.toDate = $event)),
                      class: "edit-date__calendar"
                    }, null, 512), [
                      [_vModelText, _ctx.postData.toDate]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode("table", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.dataTable, (dataRow, dataRowIndex) => {
                return (_openBlock(), _createBlock("tr", { key: dataRowIndex }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(dataRow, (dataColumn, dataColumnIndex) => {
                    return (_openBlock(), _createBlock("td", {
                      key: dataColumnIndex,
                      class: _ctx.attrs[dataRow.length * dataRowIndex + dataColumnIndex]
                    }, [
                      _createVNode("div", _hoisted_24, [
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": $event => (
                      _ctx.array[dataRow.length * dataRowIndex + dataColumnIndex]
                     = $event),
                          class: "select-attr",
                          type: "text",
                          name: ""
                        }, null, 8, ["onUpdate:modelValue"]), [
                          [_vModelText, 
                      _ctx.array[dataRow.length * dataRowIndex + dataColumnIndex]
                    ]
                        ]),
                        _withDirectives(_createVNode("select", {
                          onChange: $event => (_ctx.checkingCells(dataRowIndex, dataColumnIndex)),
                          class: "select-type",
                          "onUpdate:modelValue": $event => (
                      _ctx.attrs[dataRow.length * dataRowIndex + dataColumnIndex]
                     = $event),
                          name: ""
                        }, [
                          _hoisted_25,
                          _hoisted_26,
                          _hoisted_27,
                          _hoisted_28
                        ], 40, ["onChange", "onUpdate:modelValue"]), [
                          [_vModelSelect, 
                      _ctx.attrs[dataRow.length * dataRowIndex + dataColumnIndex]
                    ]
                        ]),
                        (
                      _ctx.attrs[dataRow.length * dataRowIndex + dataColumnIndex] ==
                      'attr'
                    )
                          ? (_openBlock(), _createBlock("div", _hoisted_29, [
                              _hoisted_30
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _createVNode("div", _hoisted_31, [
            _createVNode("button", {
              class: "button-using",
              onClick: _cache[5] || (_cache[5] = $event => (_ctx.takeBulletin()))
            }, "ИМПОРТ"),
            _createVNode(_component_router_link, {
              class: "admin-article-create",
              "active-class": "active",
              to: "/admin/import",
              exact: ""
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            }),
            _withDirectives(_createVNode("p", _hoisted_33, " ошибка при импортировании! ", 512), [
              [_vShow, _ctx.errorIsActive]
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.changeActive)
          ? (_openBlock(), _createBlock("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _createVNode("span", {
                  class: "close",
                  onClick: _cache[6] || (_cache[6] = $event => (_ctx.changeActive = !_ctx.changeActive))
                }, "×"),
                _createVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createVNode("div", _hoisted_38, [
                    _createVNode("button", {
                      class: "button button--primary form__button form__button1",
                      onClick: _cache[7] || (_cache[7] = $event => (_ctx.changeActive = !_ctx.changeActive))
                    }, _toDisplayString(_ctx.$t('admin.yes')), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64 /* STABLE_FRAGMENT */))
}